interface DecodedToken {
    sub: string;
    email: string;
    [key: string]: any;
}

export const decodeJWT = (token: string): DecodedToken | null => {
    try {
        const parts = token.split(".");

        if (parts.length !== 3) {
            throw new Error("Invalid JWT format");
        }

        const payload = parts[1];

        const paddedPayload = payload + "=".repeat((4 - (payload.length % 4)) % 4);

        const standardBase64 = paddedPayload.replace(/-/g, "+").replace(/_/g, "/");

        const decoded = atob(standardBase64);

        return JSON.parse(decoded);
    } catch (error) {
        return null;
    }
};

export const getTokenValue = () => {
    if (typeof window === "undefined") {
        return null;
    }

    const token = localStorage.getItem("token");

    if (!token) {
        return null;
    }

    const decoded = decodeJWT(token);

    if (!decoded) {
        return null;
    }

    return decoded || null;
};

export const getDecodedToken = (): DecodedToken | null => {
    if (typeof window === "undefined") {
        return null;
    }

    const token = localStorage.getItem("token");

    if (!token) {
        return null;
    }

    return decodeJWT(token);
};
